import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Analyzer } from 'types';
import { UpdateAnalyzer as UpdateAnalyzerDto } from '../types';
import { convertAnalyzer } from 'api/dtoConverters';

export const updateAnalyzer = async ({
  data,
  analyzerId,
}: {
  data: UpdateAnalyzerDto;
  analyzerId: number;
}): Promise<Analyzer> => {
  const response = await axios.put(
    `/api/analyzers/${analyzerId}`,
    convertAnalyzer(data)
  );
  return response.data as Analyzer;
};

type UseUpdateAnalyzerOptions = {
  config?: MutationConfig<typeof updateAnalyzer>;
};

export const useUpdateAnalyzer = ({
  config,
}: UseUpdateAnalyzerOptions = {}) => {
  return useMutation({
    onMutate: async (updatingAnalyzer: any) => {
      await queryClient.cancelQueries(['analyzer', updatingAnalyzer?.id]);

      const previousAnalyzer = queryClient.getQueryData<Analyzer>([
        'analyzer',
        updatingAnalyzer?.id,
      ]);

      queryClient.setQueryData(['analyzer', updatingAnalyzer?.id], {
        ...previousAnalyzer,
        ...updatingAnalyzer.data,
        id: updatingAnalyzer.id,
      });

      return previousAnalyzer;
    },
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzer) {
        queryClient.setQueryData(
          ['analyzer', context.previousAnalyzer.id],
          context.previousAnalyzer
        );
      }
    },
    onSuccess: (data: Analyzer) => {
      queryClient.invalidateQueries(['analyzer', data.id]);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: updateAnalyzer,
  });
};
